import { createContext, useContext } from "react";
import { DEFAULT_LOCALE, getLocaleMeta, type Locale } from "@/lib/i18n-config";

export type I18nValue = {
  locale: string;
  meta: Locale;
  /** Translate a literal string held in a component. */
  t: (text: string) => string;
  /** Rewrite an internal href for the active locale. */
  localizeHref: (href: string) => string;
};

export const I18nContext = createContext<I18nValue>({
  locale: DEFAULT_LOCALE,
  meta: getLocaleMeta(DEFAULT_LOCALE),
  t: (text) => text,
  localizeHref: (href) => href,
});

export function useI18n(): I18nValue {
  return useContext(I18nContext);
}

